import { render } from "./CollapsibleSection.vue?vue&type=template&id=cc866934&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=cc866934&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc866934"]])

export default __exports__